if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        // ════════════════════════════════════════════════════════
        // ECS ADD ESENCIA — Integración con product-form.js
        //
        // Antes de agregar el difusor al carrito, revisamos si
        // el widget de esencia está activo (window.ecsEstadoEsencia).
        // Si lo está, primero agregamos la esencia via Cart API
        // y después continuamos con el flujo normal del difusor.
        // Si no está activo, el flujo es exactamente igual al original.
        // ════════════════════════════════════════════════════════
        
this.procesarAddToCart(formData, config, evt);
      }

      // Método que decide si agrega esencia primero o va directo
      procesarAddToCart(formData, config, evt) {
        const ecsEstado = window.ecsEstadoEsencia;
        const debeAgregarEsencia = ecsEstado &&
          ecsEstado.activo &&
          ecsEstado.variantId &&
          !ecsEstado.yaAgregando;

        if (debeAgregarEsencia) {
          ecsEstado.yaAgregando = true;

          const itemEsencia = { id: ecsEstado.variantId, quantity: 1 };
          if (ecsEstado.sellingPlanId) {
            itemEsencia.selling_plan = ecsEstado.sellingPlanId;
          }

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [itemEsencia] })
          })
          .then((r) => {
            if (!r.ok) throw new Error('ECS: Error al agregar esencia, status ' + r.status);
            return r.json();
          })
          .then(() => {
            ecsEstado.yaAgregando = false;
            this.ejecutarAddToCart(formData, config, evt);
          })
          .catch((err) => {
            console.error('[ECS Add Esencia]', err);
            ecsEstado.yaAgregando = false;
            this.ejecutarAddToCart(formData, config, evt);
          });

        } else {
          this.ejecutarAddToCart(formData, config, evt);
        }

        // ════════════════════════════════════════════════════════
        // FIN ECS ADD ESENCIA
        // ════════════════════════════════════════════════════════
      }

      // ── Método extraído del flujo original ──
      // Contiene exactamente el mismo fetch que tenía Dawn antes,
      // separado en su propio método para poder llamarlo
      // después de agregar la esencia.
      ejecutarAddToCart(formData, config, evt) {
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
